import React from "react";
import "./Loginheader.css";
import logo from "../../assests/BEMSS1.png";

import overlay_video from "../../assests/balloons_transparent.gif";

export default function Loginheader() {

    const isMobile = window.innerWidth < 768;

    return (
        <header className="loginheader" style={{ position: "relative", overflow: "hidden", background: "linear-gradient(135deg, #efb871 0%, #ffffff 35%, #ffffff 35%, #66ec95 100%)" }}>
            {
                isMobile ? (
                    <img src={logo} style={{ width: '150px', height: '40px' }} alt="App Logo" className="logo" />
                ) :
                    (
                        <img src={logo} alt="App Logo" className="logo" />
                    )
            }


        </header>
    );
}